exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-2a76d781]{width:100%}body[data-v-2a76d781]{overflow-y:hidden}.about[data-v-2a76d781]{margin-top:-80px}.about .sketch[data-v-2a76d781]{text-indent:2em;font-size:20px;font-weight:700}.about .padding-top[data-v-2a76d781]{padding-top:58px}.about .padding-top-xs[data-v-2a76d781]{padding-top:28px}.about .padding-bottom[data-v-2a76d781]{padding-bottom:75px}.about .title[data-v-2a76d781]{color:#ecac1b;font-size:20px;line-height:40px;font-weight:700}.about .text[data-v-2a76d781]{margin:0 auto;width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a76d781","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pcAbout.vue
// module id = 140
// module chunks = 0